import React from 'react';
import { useSelector } from 'react-redux';
import {RootState} from "../../store";
import Verify2fa from "../verify2fa";
import VerifyEmail from "../verifyEmail";

interface VerifyWrapperProps {
  children: React.ReactElement | React.ReactElement[]
}

const VerifyWrapper = (props: VerifyWrapperProps) => {

  const verifyingEmail = useSelector((state: RootState) => state.auth.verifyingEmail);
  const verifying2FA = useSelector((state: RootState) => state.auth.verifying2FA);

  if(verifying2FA) {
    return <Verify2fa/>
  } else if(verifyingEmail) {
    return <VerifyEmail/>
  } else {
    return <>{props.children}</>
  }

}

export default VerifyWrapper;
